import axios from 'axios'
import decryptData from '@/store/auth/decryptData'

export default {
  namespaced: true,
  state: () => ({
    role: [],
    roleLoaded: false,
  }),
  mutations: {
    SET_Roles(state, roles) {
      state.role = roles
      state.roleLoaded = true
    },
  },
  actions: {
    async fetchRoles({ commit, state }) {
      if (!state.roleLoaded) {
        const res = await axios.get('register/site/roles')
        const data = decryptData(res.data.payload).data.roles
        const formatted = data.map(item => ({
          value: item.name,
          id: item.id,
          text: item.name,
        }))
        commit('SET_Roles', [{ value: null, text: 'All Roles' }, ...formatted])
      }
    },
  },
  getters: {
    roles: state => state.role,
    rolesLoaded: state => state.roleLoaded,
  },
}
